module.exports = __webpack_public_path__ + "static/media/8OLA22.d690be59.jpg";